const getLocalStorageItem = key => localStorage.getItem(key);

export default getLocalStorageItem;
